module.exports = __webpack_public_path__ + "img/customer-service.8b575961.svg";